import React from "react";

interface DataExceptionProps {
    message?: string;
    containerClassName?: string;
    style?: React.CSSProperties;
}

const DataException: React.FC<DataExceptionProps> = ({
    message, containerClassName, style
}) => {
    return (
        <div className={`no_records_found ${containerClassName ? containerClassName : ''}`} style={style}>
            <p className="no_records_found_text">
                <i className="bi bi-exclamation-circle me-1"></i>
                {message ? message : 'No data found!'}
            </p>
        </div>
    )
}

export default DataException;